package com.eladfinish.bible.contest.screens.main.usecases

import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.announcement
import com.eladfinish.bible.contest.common.gender.getHebrewGender
import com.eladfinish.bible.contest.common.gender.personalizeGender
import com.eladfinish.bible.contest.constants.Constants.ANNOUNCEMENT_STR
import com.eladfinish.bible.contest.constants.StringConstants.Regex.WORD_CHAR
import com.eladfinish.bible.contest.data.common.stringResolver.StringResolver
import com.eladfinish.bible.contest.download_gendered
import com.eladfinish.bible.contest.extensions.replaceRegex
import com.eladfinish.bible.contest.repository.remoteConfig.RemoteConfig
import com.eladfinish.bible.contest.usecase.GetRemoteConfigValueUseCase
import com.eladfinish.bible.contest.utils.unescapeJava
import com.russhwolf.settings.Settings
import dev.icerock.moko.resources.desc.desc

class GetAnnouncementUseCase(
    private val stringResolver: StringResolver,
    private val settings: Settings,
    private val getRemoteConfigValueUseCase: GetRemoteConfigValueUseCase,
) {

    operator fun invoke(): String {
        val defaultValue = stringResolver.resolveString(SharedRes.strings.announcement.desc())
        val cachedValue = settings.getString(ANNOUNCEMENT_STR, "").takeIf { it.isNotBlank() }

        val remoteValue: String? = runCatching {
            getRemoteConfigValueUseCase
                .get<String>(RemoteConfig.ANNOUNCEMENT)
                ?.let { unescapeJava(input = it) } // if announcement contains "\n", treat it as a new line
                ?.takeIf { it.isNotBlank() }
        }.getOrNull()

        val chosen = remoteValue ?: cachedValue ?: defaultValue

        if (remoteValue != null && remoteValue != cachedValue) {
            settings.putString(ANNOUNCEMENT_STR, remoteValue)
        }

        return chosen.personalizeAnnouncement()
    }

    private fun String.personalizeAnnouncement(): String {
        return replaceDownloadVerb(
            replacement = stringResolver.resolveString(SharedRes.strings.download_gendered.desc())
        ).personalizeGender(hebrewGender = settings.getHebrewGender())
    }
}

// WORD_CHAR lookarounds rather than \b: JS RegExp's \b is ASCII-only (see WORD_CHAR)
internal fun String.replaceDownloadVerb(replacement: String): String =
    replaceRegex(
        regex = "(?<!$WORD_CHAR)הורד(?!$WORD_CHAR)",
        replacement = replacement,
    )
